import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "app-release-state-cell-renderer",
  templateUrl: "./version-state.renderer.html",
})
export class VersionStateCellRenderer implements ICellRendererAngularComp {
  value!: string;
  label!: string;

  agInit(params: ICellRendererParams): void {
    this.value = (params.data?.status ?? "").toLowerCase();
    this.label = this.value === "published" ? "Published" : "Draft";
  }

  refresh(): boolean {
    return false;
  }
}
